import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_12ARed_12DRed = () => <CrossRoad coords="2287.000000, 376.000000" color={tracksColors.red}/>;
export default CrossRoad_12ARed_12DRed;
